export const languagesMapping = {
  ITA: 'it-IT',
  DEU: 'de-DE',
  ENG: 'en-US',
  FRA: 'fr-FR',
};
